import { LocationFormlyFieldService } from '@core/services/formly-service/location-formly-field.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export function closureLocation(
  translateService: TranslateService,
  locationFormlyFieldService: LocationFormlyFieldService,
  onSelectLocation: (id: string) => void,
  weNo?: string | null,
  tooltip?: string
): Array<FormlyFieldConfig> {
  return [
    {
      wrappers: [],
      fieldGroup: [
        {
          type: 'chapter',
          props: {
            chapterTitle: translateService.instant(
              'ticket.create.headline__closure_location'
            ),
          },
        },
        {
          key: 'searchLocation',
          fieldGroup: [
            ...locationFormlyFieldService.autocompleteSearch(
              false,
              { id: weNo },
              true,
              onSelectLocation,
              null,
              null,
              tooltip
            ),
          ],
        },
      ],
    },
  ];
}
